import React from 'react';
import { Map } from 'lucide-react';

interface MapSkeletonProps {
  'aria-hidden'?: boolean;
}

export default function MapSkeleton({ 'aria-hidden': ariaHidden }: MapSkeletonProps) {
  return (
    <div 
      className="w-full h-full bg-gray-800 rounded-lg flex items-center justify-center" 
      aria-label="Map loading"
      aria-hidden={ariaHidden}
    >
      <div className="text-center">
        <Map className="w-12 h-12 text-gray-600 mb-4 mx-auto animate-pulse" />
        <p className="text-gray-400">Loading map...</p>
      </div>
    </div>
  );
}